import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_CLOSE_BUTTON,
  GENERIC_MODAL_IMPORT_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import { IMPORT_MODAL_STEPS } from '@commons/Modals/MultiStepModal';

import { getValidationFileConfig } from '@commons/Modals/MultiStepModal';

import ImportExcelFileModal from '@backoffice/components/ImportExcelFileModal';

const COMMON_FILE_CONFIG = {
  width: '542px',
  height: 'auto',
  component: ImportExcelFileModal,
};

export const getUpdateProductModalConfig = (step, props) => {
  switch (step) {
    case IMPORT_MODAL_STEPS.SELECT_FILE:
      return getSelectFileConfig(props);
    case IMPORT_MODAL_STEPS.VALIDATE_FILE:
      return getValidationFileConfig({
        ...props,
        title: i18next.t('ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_TITLE'),
        subTitle: i18next.t('ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_SUBTITLE'),
      });
    case IMPORT_MODAL_STEPS.VALIDATED_FILE:
      return getValidatedFileConfig(props);
    case IMPORT_MODAL_STEPS.PARTIALLY_VALIDATED_FILE:
      return getPartiallyValidatedFileConfig(props);
    case IMPORT_MODAL_STEPS.ERROR_FILE:
      return getErrorFileConfig(props);
    default:
      return {
        width: '542px',
        height: 'auto',
        component: ImportExcelFileModal,
      };
  }
};

export const getSelectFileConfig = ({ selectedFile, handleFileChange, handleCloseCleanUp }) => ({
  ...COMMON_FILE_CONFIG,
  type: 'action',
  title: i18next.t('ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_TITLE'),
  icon: '/images/inpulse/file-upload-black-small.svg',
  handleCloseCleanUp,
  data: {
    subTitle: i18next.t('ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_SUBTITLE'),
    selectedFile,
    setSelectedFile: (file) => handleFileChange(file),
  },
  actions: [
    {
      ...GENERIC_MODAL_CANCEL_BUTTON(),
      handleClick: handleCloseCleanUp,
    },
    {
      ...GENERIC_MODAL_IMPORT_BUTTON(),
      isDisabled: true,
      handleClick: () => false,
    },
  ],
});

const getValidatedFileConfig = ({
  updatedFile = null,
  handleFileImport,
  storeName,
  handleCloseCleanUp,
}) => ({
  ...COMMON_FILE_CONFIG,
  type: 'success',
  title: i18next.t('GENERAL.IMPORT_FILE_NO_ERROR_TITLE_MODAL'),
  icon: '/images/inpulse/check-white-small.svg',
  handleCloseCleanUp,
  data: {
    subTitle: i18next.t('ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_SUBTITLE_SUCCESS', {
      storeName,
    }),
    validatedFile: true,
    selectedFile: updatedFile,
  },
  actions: [
    {
      ...GENERIC_MODAL_IMPORT_BUTTON(),
      handleClick: handleFileImport,
    },
  ],
});

export const getPartiallyValidatedFileConfig = ({
  updatedFile = null,
  handleFileImport,
  exportErrors,
  unValidatedLines,
  handleCloseCleanUp,
}) => ({
  ...COMMON_FILE_CONFIG,
  type: 'warning',
  title: i18next.t('ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_TITLE'),
  icon: '/images/inpulse/warning-white-small.svg',
  handleCloseCleanUp,
  data: {
    subTitle: i18next.t('ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_SUBTITLE_PARTIALLY_VALIDATED'),
    validatedFile: true,
    selectedFile: updatedFile,
    unValidatedLines,
    exportXLS: exportErrors,
  },
  actions: [
    {
      ...GENERIC_MODAL_CANCEL_BUTTON(),
      handleClick: handleCloseCleanUp,
    },
    {
      ...GENERIC_MODAL_IMPORT_BUTTON(),
      handleClick: handleFileImport,
    },
  ],
});

export const getErrorFileConfig = ({ updatedFile, handleCloseCleanUp }) => {
  const data = {
    subTitle: i18next.t('ADMIN.SUPPLIER_PRODUCTS.MODAL_IMPORT_TEMPLATE_SELECT_FILE_ERROR_SUBTITLE'),
    additionalText: i18next.t(
      'ADMIN.PRODUCTS.BATCH_UPDATE_IMPORT_MODAL_FILE_IMPORT_ERROR_SUBTITLE',
    ),
    validatedFile: false,
    selectedFile: updatedFile,
  };

  return {
    ...COMMON_FILE_CONFIG,
    type: 'error',
    title: i18next.t('ADMIN.SUPPLIER_PRODUCTS.MODAL_IMPORT_TEMPLATE_BATCH_SELECT_FILE_ERROR_TITLE'),
    icon: '/images/inpulse/info-white-small.svg',
    handleCloseCleanUp,
    data,
    actions: [
      {
        ...GENERIC_MODAL_CLOSE_BUTTON(),
        handleClick: handleCloseCleanUp,
      },
    ],
  };
};
